import React from 'react';
import styled, { StylesProps, cx, useStyles } from '../../../lib/styles';
import BlockWrapper from '../BlockWrapper';
import { CallToActionButton } from '../CallToActionButton';
import { ButtonPosition, DefaultBlockFields } from '../GroupBlock';

import titleBlockStyles from './TitleBlock_styles';
import Typography from '../../../components/presentational/Typography';
import { Brand } from '../../../lib/theme';
import Spacer from '../../../components/presentational/Spacer';
import globalStyles from '../../../lib/styles/Global_styles';
import BlockTitle from '../BlockTitle';
import _ from 'lodash';

export interface TitleBlockProps {
  type: 'acf_title_block';
  brand: string;
  classes: string;
  background_colour: string;
  desktop_spacing: string;
  mobile_spacing: string;
  block: DefaultBlockFields;
}

export interface TitleBlockFields extends DefaultBlockFields {}

const TitleBlock = ({
  type,
  classes,
  brand,
  background_colour,
  desktop_spacing,
  mobile_spacing,
  block: { title },
  styles,
}: TitleBlockProps & StylesProps<typeof titleBlockStyles>) => {
  // console.log('Content Block', {content});

  const globals = useStyles(globalStyles());

  return (
    <BlockWrapper
      {...{
        type,
        classes,
        brand,
        background_colour,
        desktop_spacing,
        mobile_spacing,
      }}
    >
      <Spacer
        space={['m', 'l']}
        className={cx(`title-container container`, styles.container, classes)}
      >
        <h1 className={styles.pageTitle}>{title}</h1>
      </Spacer>
    </BlockWrapper>
  );
};

export default styled(titleBlockStyles)(TitleBlock);
